<template>
<div class="mt-3 py-5">
	<b-container class="px-3 p-md-0">
		<b-row>
			<b-col cols="12" md="8" class="m-auto px-3">

        <div class="container">

					<div class="row justify-content-center pt-2 pb-5">

              <nav class="pankuzu w-100">
                <ul class="my-4">
                  <li><img class="" src="/static/img/icon/pankuzu.png" style="height: 17px;padding-bottom: 3px;"><a @click="jump(0)">  ピアチュウ TOP</a></li>
                  <li>  ピアノ販売者の登録について</li>
                </ul>
              </nav>

              <div class="card">
                <div class="card-header text-center">
                  <font size="5">
                    <strong>無料で効果的に在庫の中古ピアノを宣伝、告知できます</strong>
                  </font>～ピアノ販売事業者様のご登録について～
                </div>
                <div class="card-body">
                  <p>中古ピアノの販売事業では、申し上げるまでもなく、ピアノを欲しいと検討中のユーザーに、いかに適切にアプローチできるかが大切になります。それができないと、在庫が動かない状態となってしまい、事業が停滞してしまいます。したがって、有望なユーザーが常に訪れて購入し、在庫が常に入れ替わっている状態が望ましいと言えます。　つまり、新規の有望なユーザーを常に獲得し続けなければなりません。 でも、多大な広告費や労力をかけることは大変です。広告のやり方が上手くないと、損失だけが大きく膨らむこともあり得ます。 それよりも、整備によってピアノを良くすることや既に顧客となっているピアノユーザーのサポートに全力を傾けたほうが御社の強味を活かせるのではないでしょうか。 ピアチュウに登録すれば、ピアノに興味持っている有望なユーザーの募集を、登録料などゼロ円で簡単に行うことができます。</p>
                  <br>
                  <h2>登録の対象はピアノ販売事業者様のみで、登録は推薦制となります</h2>
                  <p>ご登録はピアノ販売等に関わる事業で実績のある事業者様のみとさせていただきます。個人事業主様やピアノ調律師様もご登録の対象となります。（一般ユーザー様でピアノを一台だけ売りたいといった方は登録の対象外となります）
                    <br>
                    また販売事業者様全体の信頼度を高めるため、新規登録には推薦制を採用しております。すなわち、既に当サイトに登録された事業者様からの推薦があった場合にのみ、新規登録可能となります。新規登録される際は、どの事業者様からの推薦があったのかを明示ください。（尚、当サイトから新規登録をお願いする場合は、この限りではありません） 
                  </p>
                  <br>
                  <h2>新規登録も商品掲載も無料です（成果販売手数料のみ）</h2>
                  <p>新規登録及び商品掲載は無料で、毎月の固定費用は発生いたしません。ただし、実際に掲載されている中古ピアノをユーザーが購入した場合のみ、成果に応じた販売手数料をお支払いいただきます。（詳しくは、 
                    <strong><a href="https://www.piachu.net/charge_seller">こちら</a></strong>を御覧ください。） 
                  </p>
                  <br>
                  <h2>登録は20分で完了！　無料で中古ピアノ販売事業の集客ページを作成します</h2>
                  <p>まずは販売事業者として登録をしていただきます。その後は、販売したい商品（ピアノ）の情報を、フォームから入力をするだけで簡単に商品ページを作成できます。一度にたくさんの商品情報を入力するのはたいへんなので、まずは1つ、2つの掲載からでだいじょうぶです。
                    <br>ここから、掲載のスタートです。
                    <br>あとはページを見たユーザーからの試弾申し込みや、購入申し込みを待つだけ。（もしコメントが送られてきた場合は、返答をお願いします。）費用も手間も要りません。
                    <br>※これら登録、作成は、スマートフォンからでもすべてできます。
                  </p>
                  <br>
                  <h2>顧客管理に便利な機能を搭載</h2>
                  <p>中古ピアノ販売事業者として登録をすると、商品（ピアノ）をいくつでも自由に追加できます。
                    <br>問い合わせや商品へのコメント、及び試弾の申し込み者、購入の申込者とは、メッセージ（チャット）機能でやりとり可能。電話で対応できない場合も履歴が残るため安心です。
                    <br>※これら顧客管理やメッセージ機能は、スマートフォンでも使用できます。
                  </p>
                  <br>
                  <h2>口コミ、評価や実績がたまります</h2>
                  <p>購入申し込みをしたユーザーからの口コミが入り評価が増えていくと、検索数が増え、申込みされやすくなります。
                    <br>実績が増え、高い評価を獲得すれば、ピアノ販売事業者としてのブランディングにつながります。
                  </p>
                  <br>
                  <h2>中古ピアノ販売事業者としてのご登録は <a href="https://www.piachu.net/sign_up?user_type=2">こちら</a>から 
                  </h2>
                </div>
              </div>

					</div>

        </div>

			</b-col>
		</b-row>
	</b-container>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'SellerRegistration',
  data() {
    return {
    }
  },
  methods: {
    jump(number) {
      if (number==0) {
        this.$router.push({path: '/'});
      }
    },
  },
	computed: {
	},
  created() {
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SellerRegistration.vue